import React, { useState, useEffect, useCallback, useRef } from 'react'
import { Pickup } from '../pickup/Pickup'
import Preloader from '../preloader/Preloader'
import './delivery.scss'

function Delivery() {
    const [isLoading, setIsLoading] = useState(true);
    const [deliveryVariants, setDeliveryVariants] = useState([]);

    const [cityName, setCityName] = useState("city");

    const cityRef = useRef(null);
    const cityIntervalRef = useRef(null);
    
    const refreshRef = useRef(false);
    const mounted = useRef(false);

    const getDeliveryVariants = useCallback(() => {
        if(!mounted.current) {
            setIsLoading(true);
       
            if (cityIntervalRef.current !== null) {
                clearInterval(cityIntervalRef.current);
                cityIntervalRef.current = null;
            }
    
            const formData = new FormData();
    
            if(cityRef.current.innerHTML !== "city") {
                formData.append('cityName', cityRef.current.innerHTML);
                cityRef.current.innerHTML = "city";
                setCityName("city");
            }
    
            fetch(`/bitrix/services/main/ajax.php?mode=class&c=interes_v2:pickuppoints.list&action=getPointList`, {
                method: 'POST',
                body: formData
              }).then(res => res.json())
                .then(res => {               
                    setDeliveryVariants(JSON.parse(res.data));
                    refreshRef.current = true;
                }).catch(e => {
                    console.log(e);
                });  
            
            mounted.current = true;  
        }                
    }, [])

    useEffect(() => {
        getDeliveryVariants();
    }, [getDeliveryVariants, cityName]);

    useEffect(() => {
        if(refreshRef.current) {
            setIsLoading(false);

            cityIntervalRef.current = setInterval(() => {
                if(cityRef.current !== null) {
                    if(cityRef.current.innerHTML !== cityName) {
                        setCityName(cityRef.current.innerHTML);
                        mounted.current = false;
                    }
                }                    
            }, 1000);

            refreshRef.current = false;
        }
    }, [deliveryVariants]);

    return (
        <>
        <h2 ref={cityRef} className="city_fake city_name">city</h2>        
        {isLoading ? <Preloader/> : <Pickup deliveryVariants={deliveryVariants} />}
        </>
    );
}

export {Delivery}